// Lightweight conversion-tracking layer.
// Pushes events to window.dataLayer so GTM/GA4 can pick them up once a
// container ID is added — no external script required for now.
export function trackEvent(event, params = {}) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
}

export const trackEstimate = (location) => trackEvent("estimate_request", { location });
export const trackWhatsApp = (location) => trackEvent("whatsapp_click", { location });
export const trackPhone = (location) => trackEvent("phone_click", { location });
export const trackLeadSubmit = (source) => trackEvent("lead_form_submit", { source });
